import { LoquixParameterPanel } from './loquix-parameter-panel.js';

if (!customElements.get('loquix-parameter-panel')) {
  customElements.define('loquix-parameter-panel', LoquixParameterPanel);
}
